<template>
  <div>
    <v-container fluid grid-list-xl>
      <!-- Visitors & Page views -->
      <!-- <v-layout row wrap>
        <v-flex xs12 md9>
          <v-card>
            <v-toolbar color="transparent" flat>
              <v-toolbar-title>Exames e Procedimentos</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
            </v-toolbar>
            <!-- <v-card-title primary-title class="title my-0">Visitors & Page views</v-card-title> -->
            <!-- <v-card-text>
              <line-chart
                :data="visitorsPageViews.data"
                :options="visitorsPageViews.option"
                :height="113"
              ></line-chart>
            </v-card-text>
          </v-card>          
        </v-flex>
        <v-flex xs12 md3>
          <v-card>
            <v-toolbar color="transparent" flat>
              <v-toolbar-title>Movimentação diária</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon>
                <v-icon>more_horiz</v-icon>
              </v-btn>
            </v-toolbar> -->
            <!-- <v-card-title primary-title class="title my-0">Visitors & Page views</v-card-title> -->
            <!-- <v-card-text class="text-xs-center">
              <v-progress-circular
                :rotate="-90"
                :value="70"
                :size="240"
                :width="15"
                color="primary"
              >
                <span class="grey--text">Valores e receber</span><br>
                <strong>{{today}}</strong>
              </v-progress-circular>
              <div class="title my-2">R$ 18,950.00</div>
              <span class="subheading grey--text">Este ciclo de faturamento</span>
            </v-card-text>
          </v-card>          
        </v-flex>
        <v-flex xs12 md3>
        </v-flex>
      </v-layout> -->
    </v-container>
    <v-container fluid grid-list-xl>
      <!-- Revenue Section -->
      <v-layout row wrap>
        <v-flex xs12>
        </v-flex>
      </v-layout>

      <!-- <v-layout row wrap>
        <v-flex xs12 sm6 md12>
          <v-card-title primary-title class="title my-0">Agenda Semanal</v-card-title>
          <calendar-week/>
        </v-flex>
      </v-layout> -->

      <v-layout row wrap>
        <v-flex xs12 md12>
          <v-card>
            <v-toolbar color="transparent" flat>
              <v-toolbar-title>Período: {{period.start}} até {{period.end}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
            </v-toolbar>
            <!-- <v-card-title primary-title class="title my-0">Visitors & Page views</v-card-title> -->
            <v-card-text>
              <v-data-table
                :headers="headers"
                :items="items"
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-left">{{ props.item.covenant }}</td>
                  <td class="text-xs-center">{{ props.item.mount }}</td>
                  <td class="text-xs-center">{{ props.item.value | currency }}</td>
                  <!-- <td class="text-xs-center">{{ props.item.crm }}</td>
                  <td class="text-xs-left">{{ props.item.doctor }}</td> -->
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

    </v-container>
  </div>
</template>
<script>
  // Components
  import CalendarWeek from '../../components/schedule/week.vue'
  import CalendarCompleted from '../../components/schedule/completed'
  import LineChart from '../../components/ChartJs/LineChart'
  import { mapActions, mapGetters } from 'vuex'
  import moment from 'moment'

  // Depedencies
  export default {
    components: {
      CalendarWeek,
      CalendarCompleted,
      LineChart
    },
    computed: {
      ...mapGetters('proced', ['getList', 'getAvailableAppointments'])
    },
    methods: {
      ...mapActions('proced', ['setList', 'setAvailableAppointments'])
    },
    mounted () {
      this.setList().then(() => {
        this.items = this.getList
      })
      this.setAvailableAppointments().then(() => {
        this.getAvailableAppointments.map((item) => {
          this.month.push(item.month)
        })
      })
      this.today = moment().format('DD-MM-YYYY')
    },
    data () {
      return {
        title: 'Dashboard',
        icon: 'dashboard',
        today: null,
        period: {
          start: moment().add('months', -2).date(0).format('DD-MM-YYYY'),
          end: moment().add('months', 2).date(0).format('DD-MM-YYYY')
        },
        month: [],
        headers: [
          { text: 'Convênio', value: 'calories', align: 'left' },
          { text: 'Qtde.', value: 'protein', align: 'center' },
          { text: 'Valor', value: 'protein', align: 'center' }
          // { text: 'CRM', value: 'iron', align: 'center' },
          // { text: 'Nome', value: 'iron', align: 'left' }
        ],
        items: [],
        visitorsPageViews: {
          data: {
            labels: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
            datasets: [
              {
                label: 'Procedimentos',
                fill: false,
                data: [150, 2450, 1599, 1100, 1450, 2550, 1540, 2370, 1334, 1284, 1200, 1890],
                borderColor: this.$vuetify.theme.primary,
                pointBorderColor: this.$vuetify.theme.primary,
                pointBackgroundColor: this.$vuetify.theme.primary,
                shadowOffsetX: 3,
                shadowOffsetY: 3,
                shadowBlur: 10,
                shadowColor: 'rgba(98, 0, 234, 0.5)',
                pointRadius: 4,
                pointBevelWidth: 3,
                pointBevelHighlightColor: 'rgba(255, 255, 255, 0.75)',
                pointBevelShadowColor: 'rgba(98, 0, 234, 0.5)',
                pointHoverRadius: 6,
                pointHoverBevelWidth: 4.5,
                pointHoverInnerGlowWidth: 20,
                pointHoverInnerGlowColor: `rgba(98, 0, 234, 0.5)`,
                pointHoverOuterGlowWidth: 20,
                pointHoverOuterGlowColor: this.$vuetify.theme.secondary,
                tension: 0.15
              },
              {
                label: 'Exames',
                fill: false,
                data: [410, 380, 800, 789, 450, 550, 187, 470, 234, 984, 1024, 890].map((i) => i * 3),
                borderColor: this.$vuetify.theme.secondary,
                pointBorderColor: this.$vuetify.theme.secondary,
                pointBackgroundColor: this.$vuetify.theme.secondary,
                shadowOffsetX: 3,
                shadowOffsetY: 3,
                shadowBlur: 10,
                shadowColor: 'rgba(233, 30, 99, 0.5)',
                pointRadius: 4,
                pointBevelWidth: 3,
                pointBevelHighlightColor: 'rgba(255, 255, 255, 0.75)',
                pointBevelShadowColor: 'rgba(233, 30, 99, 0.5)',
                pointHoverRadius: 6,
                pointHoverBevelWidth: 4.5,
                pointHoverInnerGlowWidth: 20,
                pointHoverInnerGlowColor: `rgba(233, 30, 99, 0.5)`,
                pointHoverOuterGlowWidth: 20,
                pointHoverOuterGlowColor: this.$vuetify.theme.primary,
                tension: 0.15
              }
            ]
          }
        }
      }
    }
  }
</script>
<style>
  .card--flex-toolbar {
    margin-top: -64px;
  }
</style>



// WEBPACK FOOTER //
// src/views/dashboard/index.vue